module.exports = __webpack_public_path__ + "static/02-e6ab1c502d4522355b05e645c9c52f8d.jpg";